module.exports = __webpack_public_path__ + "img/pregnant.48c216d4.jpg";